export default __webpack_public_path__ + "static/media/ndtxd.734430ac.png";